(ns ui.components.alert-list.event
  (:require
   [cljs-uuid-utils.core :as uuid]
   [re-frame.core :as rf]
   [ui.components.alert-list.sub :as sub]
   [ui.fx.timeout :as timeout]))

(rf/reg-event-fx
 ::add-alert
 (fn [{db :db} [_ {:keys [id list-id hide-in-ms variant message-content] :as msg}]]
   (let [list-id (or list-id :default)
         unique-id (or id
                       (uuid/make-random-uuid))
         msg (assoc msg :id unique-id)]
     (merge
      {:db (update-in db [::sub/alerts list-id] #(vec (conj % msg)))}
      (when (number? hide-in-ms)
        {::timeout/timeout {:id      unique-id
                            :event   [::remove-alert list-id unique-id]
                            :wait-ms hide-in-ms}})))))

(rf/reg-event-fx
 ::remove-alert
 (fn [{db :db} [_ list-id alert-id]]
   (let [list-id (or list-id :default)]
     {:db (update-in db
                     [::sub/alerts list-id]
                     (fn [alerts]
                       (->> alerts
                            (remove (fn [{:keys [id]}]
                                      (= id alert-id)))
                            (vec))))})))
